/** A press that travels further than this before its `click` was a drag or a scroll, not a tap. */
export const TAP_SLOP_PX = 10;

const PointerType = { Touch: 'touch', Pen: 'pen' } as const;

/** Touch and pen have no hover: a single tap is how they open or reveal things. */
export function isTapPointer(pointerType: string): boolean {
  return pointerType === PointerType.Touch || pointerType === PointerType.Pen;
}
